<template>
    <b-modal v-model="modalAberto" size="lg" @hidden="cancelar" button-size="md" hide-footer
        :title="prefix+title" >
        <ApoliceSeguroIBPAdicionar :prefix="prefix+title " @fecharModal="cancelar" :modal="true"  :idApolice="idApolice" :id="id"></ApoliceSeguroIBPAdicionar>
    </b-modal>
</template>

<script>

import ApoliceSeguroIBPAdicionar from '@/modules/patrimonio/apolice-seguro-ibp/ApoliceSeguroIBPAdicionar.vue';

export default {
    name: "ModalModalApoliceSeguroIBPAdicionar",
    components: {
        ApoliceSeguroIBPAdicionar,
    },
    props: {
        id: Number,
        edicao: Boolean,
        idApolice: Number,
        prefix: {
            tipe: String,
            default: "",
        },
        title: {
            tipe: String,
            default: "Cadastro",
        },


    },
    data() {
        return {
            modalAberto: true,
        }
    },
    methods: {
        cancelar() {
            this.$emit('fecharModal');
        },

    }
}

</script>